// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FAQContainer {
  background-color: #f5f4fb;
  padding: 70px 40px 90px;
}

.faqHeading {
  color: #172639;
  font-weight: 800;
  font-size: 2.5rem;
  margin-bottom: 12px;
}

.faqSubheading {
  color: #6b7280;
  font-size: 1rem;
  margin-bottom: 0;
}

.faqAccordion .accordion-item {
  background-color: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 4px !important;
  margin-bottom: 1rem;
  overflow: hidden;
}

.faqAccordion .accordion-header button {
  background-color: #ffffff;
  color: #172639;
  font-weight: 700;
  box-shadow: none !important;
  padding: 20px 24px;
}

.faqAccordion .accordion-body {
  background-color: #ffffff;
  color: #555555;
  text-align: left;
  padding: 0 24px 24px;
}

.faqAccordion .accordion-body p {
  margin-bottom: 0;
  text-align: left;
}

.faqAccordion .faqList {
  margin-bottom: 0;
  padding-left: 1.2rem;
}

.faqAccordion .faqList li {
  margin-bottom: 0.35rem;
}

@media (max-width: 992px) {
  .FAQContainer {
    padding: 50px 24px 60px;
  }

  .faqHeading {
    font-size: 2.1rem;
  }
}

@media (max-width: 768px) {
  .faqHeading {
    font-size: 1.8rem;
  }

  .faqSubheading {
    font-size: 0.9rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/FAQ.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".FAQContainer {\n  background-color: #f5f4fb;\n  padding: 70px 40px 90px;\n}\n\n.faqHeading {\n  color: #172639;\n  font-weight: 800;\n  font-size: 2.5rem;\n  margin-bottom: 12px;\n}\n\n.faqSubheading {\n  color: #6b7280;\n  font-size: 1rem;\n  margin-bottom: 0;\n}\n\n.faqAccordion .accordion-item {\n  background-color: #ffffff;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px !important;\n  margin-bottom: 1rem;\n  overflow: hidden;\n}\n\n.faqAccordion .accordion-header button {\n  background-color: #ffffff;\n  color: #172639;\n  font-weight: 700;\n  box-shadow: none !important;\n  padding: 20px 24px;\n}\n\n.faqAccordion .accordion-body {\n  background-color: #ffffff;\n  color: #555555;\n  text-align: left;\n  padding: 0 24px 24px;\n}\n\n.faqAccordion .accordion-body p {\n  margin-bottom: 0;\n  text-align: left;\n}\n\n.faqAccordion .faqList {\n  margin-bottom: 0;\n  padding-left: 1.2rem;\n}\n\n.faqAccordion .faqList li {\n  margin-bottom: 0.35rem;\n}\n\n@media (max-width: 992px) {\n  .FAQContainer {\n    padding: 50px 24px 60px;\n  }\n\n  .faqHeading {\n    font-size: 2.1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .faqHeading {\n    font-size: 1.8rem;\n  }\n\n  .faqSubheading {\n    font-size: 0.9rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
